import { render, staticRenderFns } from "./SaleInput.vue?vue&type=template&id=95453d72&scoped=true&"
import script from "./SaleInput.vue?vue&type=script&lang=js&"
export * from "./SaleInput.vue?vue&type=script&lang=js&"
import style0 from "./SaleInput.vue?vue&type=style&index=0&id=95453d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95453d72",
  null
  
)

export default component.exports